import React from 'react';
import { Route } from "react-router-dom";
import redirect from '../components/redirect/redirect';
import customRequest from '../helpers/customRequest';
import getURLParameters from '../helpers/getURLParams';
import message from '../components/message/message';
import ClipLoader from "react-spinners/ClipLoader";
import * as moment from 'moment'
import buildQuery from '../helpers/buildQuery';
import ProbeHelp from '../components/help/ProbeHelp'
import { Phonics, Phrases, Stories } from '@stem-sims/great-leaps-react-common';

class Probes extends React.Component
{
    /*********************
    * Global Variables
    *********************/
    state =
    {
        //returned from API Request
        title: "",
        responses: [],
        sectionClass : null,
        groupLength  : null,
        responsesMax : null,
        indentedParagraphs : null,
        completedBefore : null,
        firstTime : null,

        //internal
        timerActive : false,
        time : 0,
        responsesCurrent : 0,
        errors : [],
        descriptionModal: "",

        //form
        timeHasError : false,
        responseHasError : false,
        
        timeError : "",
        responseError : "",
        submitting: false,
        studentCode: {
            code: null,
            expiration: null
        } 
    }

    //References
    stopButton = React.createRef()
    startButton = React.createRef()
    

    /****************
    * Custom Functions
    *****************/


    timerIdentifier = null //used to cancel the timer
    /* 
    *   Sets up timer to tick every second
    */
    startTimer = () => {

        if (!this.timerIdentifier) {
            this.setState({ "timerActive" : true })
            this.timerIdentifier = setInterval(() =>
            {
                this.setState({"time": parseInt(this.state.time) + 1})
                if (this.state.time > 59)
                {
                    this.stopTimer()
                    window.$("#stop-modal").modal("show")
                }
            }, 1000)
        }
    }

    /* 
    *   Stops the timer
    */
    stopTimer = () => {
        this.setState({ "timerActive" : false }, () => {
            clearInterval(this.timerIdentifier)
            this.timerIdentifier = null
            this.startButton.current.classList.remove("active")
            this.stopButton.current.classList.add("active")
        })
    }

    /* 
    *   Selects a response as an error
    */
    selectError = (response, errorObject) =>
    {
        var htmlResponse = window.$(`#response-${response}`)
        
        if (htmlResponse.hasClass("error"))
        {
            htmlResponse.removeClass("error")
            var newErrors = this.state.errors.filter((error) => error.response != response)
            this.setState({ "errors" :  newErrors})
        }

        else
        {
            htmlResponse.addClass("error")
            var newErrors = this.state.errors.concat({
                response: response,
                raw: errorObject
            })
            this.setState({ "errors" :  newErrors})
        }
    }

    /* 
    *   Sets number of response read
    */
    setResponses = (response) =>
    {
        this.setState({"responsesCurrent": response})
        window.$(".response").removeClass("read")
        var responses = document.getElementsByClassName("response")

        for (var index = 0; index < response; index++)
            responses[index].classList.add("read")
    }

     /* 
    *   Redirects to probe list
    */
    redirectProbeList = (type) => {
        let params = getURLParameters()
        var toRedirect = "/"
        if (type == "phonics")
            toRedirect = "/probes/phonics"
        else if (type == "phrases")
            toRedirect = "/probes/phrases"
        else if (type == "stories")
            toRedirect = `/probes/stories/${params.suggestedStory ?? "high"}`
        else if (type == "dok")
            toRedirect = `/probes/stories/${this.props.type}/${this.props.match.params.probeNumber}/success`
        
        return new Promise((resolve, reject) => {
            const standardVariables = buildQuery({ student: params.student, customer: params.customer })
            redirect.send(toRedirect + `?${standardVariables}`, () => {
                resolve()
            })
        })
    }


    /* 
    *   Callback that is called when the start button is clicked
    */
    startButtonClicked = () =>
    {
        if (this.state.time < 60)
        {
            window.scrollTo(0, 0)
            this.setResponses(0)
            this.startTimer()

            this.startButton.current.classList.add("active")
            this.stopButton.current.classList.remove("active")
        }
        
    }

    /* 
    *   Callback that is called when the stop button is clicked
    */
    stopButtonClicked = () =>
    {
        // if (this.state.time != 0 && this.state.time < 60) {
        //     this.setResponses(this.state.responsesMax)
        //     window.$("#probe-contents").popover('show')
        //     setTimeout(() => {
        //         window.$("#probe-contents").popover('hide')
        //     }, 9000)
        // }

        this.stopTimer()
    }


    doubleClickHappened = false //double click happened in the last 400ms
    clickHappened = false //click happen in the last 1.4 seconds
    clickWaiting = false // used for when a click is waiting for a double click
    /*
    *   Callback for when a response is clicked
    */
    responseClicked = (error, errorObj) =>
    {
        if (!this.state.timerActive)
        {
            if (!this.clickWaiting)
            {
                this.clickWaiting = true
                setTimeout(() =>
                {
                    if (!this.doubleClickHappened)
                    {
                        this.selectError(error, errorObj)
                    }
                    
                    
                    this.doubleClickHappened = false
                    this.clickWaiting = false
                }, 800)
            }
            else {
                //if two clicks come through then there was a double click. Some tablets don't support the double click event
                this.responseDoubleClicked(error)
            }
        }

        else
        {
            this.selectError(error, errorObj)
        }
    }

    /* 
    *   Callback for when a response is double clicked
    */
    responseDoubleClicked = (response) =>
    {
        if (!this.state.timerActive)
        {
            this.setResponses(response)
            this.doubleClickHappened = true
        }
    }

    /* 
    *   Callback for when the form is submitted
    */
    submitForm = (event) =>
    {
        event.preventDefault()
        this.setState({ submitting: true }, () => {
            let {time, responsesCurrent, responsesMax, errors} = this.state
            const { type } = this.props
            const { probeNumber } = this.props.match.params
            var errorMessages = []
            message.clear()
            if (time == 60 && responsesCurrent <= 0)
                errorMessages.push("Please double click the last word read to record the number of responses.")
            
            if (time <= 0)
                errorMessages.push("Please enter the amount of time the student took to read the exercise, up to a maximum of 60 seconds.")
            
            if (errorMessages.length > 0)
            {
                this.setState({ submitting: false })
                message.error(errorMessages)
                return
            }
            var formattedErrors = []
            for (var error of errors) {
                formattedErrors.push(error.raw)
            }

            let params = getURLParameters()
    
            customRequest.post("/api/probe",{
                "type": type,
                "probeNumber": probeNumber,
                "studentName": params.student,
                "customerUsername": params.customer,
                "time": time,
                "responses": (time < 60 && responsesCurrent != responsesMax) ? responsesMax : responsesCurrent,
                "errors": formattedErrors
            })
            .then(({data}) =>
            {
                this.setState({ submitting: false })
                if (data.valid)
                {
                    let newType
                    if (type == "phonics")
                        newType = "phrases"
                    else if (type == "phrases")
                        newType = "stories"
                    else
                        newType = "dok"
                    
                    this.redirectProbeList(newType)
                    .then(() => {
                        if (time < 60 && responsesCurrent != responsesMax) {
                            message.info("OOPS! You didn't double click/tap the last word read. Because it was submitted before time's up, we assume the student completed the exercise in under 1 minute.")
                        }
                        
                        message.success("Your student's results have been recorded for this exercise.")
                    })
                }
    
                else
                {
                    console.error({
                        "type": type,
                        "probeNumber": probeNumber,
                        "studentName": params.student,
                        "customerUsername": params.customer,
                        "time": time,
                        "responses": (time < 60 && responsesCurrent != responsesMax) ? responsesMax : responsesCurrent,
                        "errors": formattedErrors
                    })
                    message.error(data.message ?? "There has been an error handling your request.")
                }
            })
        })
    }

    /* 
    *   Callback for when the responses count is changed by the input on the page
    */
    responseChange = (event) =>
    {
        if (event.target.value <= this.state.responsesMax)
            this.setResponses(event.target.value)
        else
            this.setResponses(0)

        this.setState({responsesCurrent: event.target.value})
    }

    /* 
    *   Callback for when the time is changed by the input on the page
    */
    timeChange = (event) =>
    {
        if (parseInt(event.target.value) == event.target.value) {
            this.setState({time: parseInt(event.target.value)})
        }
    }

    /* 
    *   Callback for checking if the code is valid
    */
   checkForValidCodeTimer = null
    checkForValidCode = () => {
        if (!this.state.studentCode?.expires) return

        let now = moment()
        
        if (now.isAfter(this.state.studentCode.expires)) {
            this.redirectProbeList(this.props.type)
            .then(() => {
                message.error("Your student code just expired, a new one has been generated. Please take note and let your student know.")
            })
        }
    }


    /****************
    * React Functions
    *****************/

    componentWillUnmount() {
        if (this.checkForValidCodeTimer) {
            clearInterval(this.checkForValidCodeTimer)
        }
    }
    componentDidMount()
    {
        const { probeNumber } = this.props.match.params
        const { type } = this.props
        const params = getURLParameters()

        const standardVariables = buildQuery({ student: params.student, customer: params.customer })
        if (!params.student) {
            return redirect.send('/dashboard', () => {
                message.error("There has been an error finding your student. Please try again.")
            })
        }

        if (isNaN(probeNumber))
        {
            return redirect.send(`/probes/${type != "phonics" && type != "phrases" ? "stories/" : "" }${type}?${standardVariables}`, () => {
                message.error("There has been an error finding your probe. Please try again.")
            })
        }

        
        customRequest.get('/api/probe', {
            params: {
                studentName: params.student,
                customerUsername: params.customer,
                type: type,
                number: parseInt(probeNumber)
            }
        })
        .then((response) => {
            // this.setState(response.data, () => {
            //     window.$("#probe-contents").popover({
            //         content: "Looks like your student has finished the probe! We have autofilled the responses for you",
            //         trigger: 'manual'
            //     })
            // })

            if (response.data.valid === false) {
                var toRedirect = "/"
                if (type == "phonics")
                    toRedirect = "/probes/phonics"
                else if (type == "phrases")
                    toRedirect = "/probes/phrases"
                else
                    toRedirect = `/probes/stories/${params.suggestedStory ?? "high"}`
                
                redirect.send(toRedirect + `?${standardVariables}`,
                () => {
                    message.error(response.data.message)
                })
            }
            this.setState(response.data)
            this.checkForValidCodeTimer = setInterval(this.checkForValidCode, 1000)

            if (type != "phonics" && type != "phrases" && response.data.firstTime) {
                this.setState({descriptionModal : "Make sure your student begins each story timing by reading the title!"}, () => {
                    window.$("#description-modal").modal("show")
                })
            }

            if (type === "phonics" && probeNumber <= 6 && response.data.firstTime) {
                this.setState({descriptionModal : "Instruct your student to sound out each letter separately. Then put the sounds together and read the full word."}, () => {
                    window.$("#description-modal").modal("show")
                })
            }
        })
    }

    render()
    {
        const { title, responses, responsesMax, time, responsesCurrent, errors, groupLength, sectionClass, indentedParagraphs, descriptionModal, completedBefore, responseHasError, timeHasError, timeError } = this.state
        const { probeNumber } = this.props.match.params

        var commonRouteProps = {
            onClick : this.responseClicked,
            onDoubleClick : this.responseDoubleClicked,
            exerciseNumber : probeNumber,
            title : title,
            responses : responses,
            Help: ProbeHelp //Passing a help module manually, needs to be integrating into the common module eventually
        }

        return (
            <React.Fragment>

                {completedBefore ? <div class = "alert alert-info">Your student has already completed this exercise.</div> : ""}

                <Route exact path="/probes/phonics/:probeNumber">
                    <Phonics {...commonRouteProps} sectionClass = {sectionClass} groupLength = {groupLength}/>
                </Route>

                <Route exact path="/probes/phrases/:probeNumber">
                    <Phrases {...commonRouteProps} sectionClass = {sectionClass} />
                </Route>

                <Route exact path="/probes/stories/:educationLevel/:probeNumber">
                    <Stories {...commonRouteProps} indentedParagraphs={indentedParagraphs}/>
                </Route>

                <p>({responsesMax} responses)</p>

                <div class = "row">
                    <div class = "col-6 col-sm-4 offset-sm-2 col-md-3 offset-md-3">
                        <a id = "start-button" class = "btn btn-secondary btn-lg" ref = {this.startButton} onClick = {this.startButtonClicked}>Start</a>
                    </div>
                    
                    <div class = "col-6 col-sm-4 col-md-3">
                        <a id = "stop-button" class = "btn btn-secondary btn-lg active" ref = {this.stopButton} onClick = {this.stopButtonClicked}>Stop</a>
                    </div>
                </div>

                <hr />

                <form onSubmit={this.submitForm} class = "form-horizontal form-validate" id = "probe-form" noValidate method = "post">
                    <div class = {`form-group row ${timeHasError ? "has-error" : ""}`}>
                        <label for = "time" class = "col-3 control-label text-right">Time</label>
                        
                        <div class = "col-9 col-sm-6">
                            <div class = "input-group">
                                <input
                                    type = "number"
                                    class = "form-control"
                                    
                                    id = "time"
                                    name = "time"
                                    
                                    min = "0"
                                    max = "60"
                                    step = "1"
                                    
                                    placeholder = "Time"
                                    onChange = {this.timeChange}
                                    value = {time}
                                    disabled={this.state.submitting}
                                    
                                    required
                                    data-description = "enter the number of seconds it took your student to complete this exercise"
                                />
                                <span class = "input-group-text">seconds</span>
                            </div>
                        </div>
                    </div>

                    <div class = "form-group row">
                        <label class = "col-3 control-label text-right">Responses</label>
                        
                        <div class = "col-6">
                             <p id = "errors" class = "form-control-static text-left">{responsesCurrent}</p>
                        </div>
                    </div>
                    
                    <div class = "form-group row">
                        <label class = "col-3 control-label text-right">Errors</label>
                        
                        <div class = "col-6">
                             <p id = "errors" class = "form-control-static text-left">{errors.length}</p>
                        </div>
                    </div>
                    
                    <button type = "submit" disabled={this.state.submitting} class = "btn btn-secondary btn-lg">
                        {this.state.submitting ?
                        <ClipLoader
                            size={20}
                            color={"#123abc"}
                            loading={this.state.loading}
                            /> : "Submit" }
                    </button>
                </form>

                <div class = "modal" id = "description-modal" tabindex = "-1" role = "dialog" aria-labelledby = "description-modal-label" data-active = {true}>
                    <div class = "modal-dialog" role = "document">
                        <div class = "modal-content">
                            <div class = "modal-body">
                                {descriptionModal}
                            </div>
                            
                            <div class = "modal-footer">
                                <button type = "button" class = "btn btn-secondary center-block" data-dismiss = "modal">Okay, got it.</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class = "modal fade" id = "stop-modal" tabindex = "-1" role = "dialog" aria-labelledby = "stop-modal-label">
                    <div class = "modal-dialog" role = "document">
                        <div class = "modal-content">
                            <div class = "modal-header">
                                <h2 class = "modal-title" id = "stop-modal-label">Time's up!</h2>
                            </div>
                            
                            <div class = "modal-body">
                                <div class = "alert alert-danger">Please instruct your student to stop reading and <b>double click/tap the last word read.</b></div>
                            </div>
                            
                            <div class = "modal-footer">
                                <button type = "button" class = "btn btn-secondary center-block" data-dismiss = "modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Probes
